module.exports = __webpack_public_path__ + "img/icon-btn-state.svg";